import {
  isAdminSubdomain,
  ADMIN_PORTAL_HOME_PATH,
} from "@/utils/admin/adminSubdomain";

const MAPS_PATH = "/maps";
/** Default landing after login/signup when no `redirect` query is present. */
const POST_AUTH_HOME_PATH = MAPS_PATH;

export const getDefaultPostAuthPath = (candidate?: string | null) => {
  if (!candidate) {
    return isAdminSubdomain() ? ADMIN_PORTAL_HOME_PATH : POST_AUTH_HOME_PATH;
  }

  if (!candidate.startsWith("/") || candidate.startsWith("//")) {
    return isAdminSubdomain() ? ADMIN_PORTAL_HOME_PATH : POST_AUTH_HOME_PATH;
  }

  return candidate;
};

/** Auth URL that returns the user to the current route once the gate is satisfied (same tab). */
export const buildAuthRouteWithReturn = (
  authRoute: "/login" | "/signup" | "/verify-email",
  pathname: string,
  search: string,
) =>
  `${authRoute}?redirect=${encodeURIComponent(`${pathname}${search}`)}`;


/** Landing / marketing: always send users to the map; guests use the same route with daily sample limits. */
export const resolvePublicMapsPath = async () => MAPS_PATH;
